export enum Constants {
  MRRDisplay = 'Chargebee Retention MRR',
  PurchaseLink = 'https://www.chargebee.com/pricing/?product_name=retention',
}
